import { Typography } from '@mui/material'
import React, { useState } from 'react'
import { shallowEqual } from 'react-redux'
import { useConfirmDialog } from 'store/actions/ui.action'
import { useAppSelector } from 'store/useStoreHook'
import ConfirmDialog from './ConfirmDialog'
import WarningDialog from './WarningDialog'

export default function GlobalConfirmDialog() {
    const { closeDialog } = useConfirmDialog()
    const [isLoading, setIsLoading] = useState(false)
    const { message, isWarning, callback, ...props } = useAppSelector(
        (state) => state.ui.confirmDialog,
        shallowEqual,
    )

    const onDialogResult = async (result: boolean) => {
        setIsLoading(true)
        await callback?.(result)
        setIsLoading(false)
        closeDialog()
    }
    if (isWarning)
        return (
            <WarningDialog
                fullWidth
                maxWidth="sm"
                {...props}
                onSave={() => onDialogResult(true)}
                onDiscard={() => onDialogResult(false)}
            >
                <Typography>{message}</Typography>
            </WarningDialog>
        )
    return (
        <ConfirmDialog
            fullWidth
            maxWidth="sm"
            {...props}
            disabledConfirm={isLoading || props.disabledConfirm}
            onSave={() => onDialogResult(true)}
            onDiscard={() => onDialogResult(false)}
        >
            <Typography>{message}</Typography>
        </ConfirmDialog>
    )
}
